/**
 * /dashboard/accounting/money/payments — Payments list (G_ACC6c).
 *
 * AP mirror of the Receipts list.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/money/payments/page.tsx.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { PaymentList } from "@/components/accounting/payment-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/accounting/money/payments/")({
  component: PaymentsListRoute,
});

function PaymentsListRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <AccountingModuleShell
      title="Payments"
      description="Vendor payments applied to bills, with TDS withholding support."
      actions={
        <>
          <Button asChild className="gap-1.5">
            <Link to="/app/$tenantSlug/accounting/money/payments/new" params={{ tenantSlug }}>
              <Plus aria-hidden className="h-4 w-4" />
              New Payment
            </Link>
          </Button>
        </>
      }
    >
      <PaymentList />
    </AccountingModuleShell>
  );
}
